module.exports = __webpack_public_path__ + "static/media/ic-credit-card.96e567c7.svg";